/* Approved product-page interactions. Checkout lives in mp-commerce.js. */
(() => {
  'use strict';
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];
  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const motion = () => reduceMotion.matches ? 'auto' : 'smooth';
  $$('a[href^="#"]').forEach(link => link.addEventListener('click', event => {
    const target = document.getElementById(link.getAttribute('href').slice(1));
    if (target) { event.preventDefault(); target.scrollIntoView({behavior:motion(), block:'start'}); }
  }));
  const dialog = $('.mv-preview-dialog');
  function showPreview(message) {
    $('#preview-message').textContent = message;
    dialog.showModal();
  }
  dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
  $('.mv-nr-write').addEventListener('click', () => showPreview('Please use the review invitation from your order to share your experience.'));

  // Uncluttered announcement rotation; pause on hover and honor reduced motion.
  const messages = $$('.mv-announcement-item');
  const promo = $('.mv-announcement');
  let activePromo = 0;
  function showPromo(index) {
    activePromo = (index + messages.length) % messages.length;
    messages.forEach((el, i) => {
      el.classList.toggle('is-active', i === activePromo);
      el.setAttribute('aria-hidden', String(i !== activePromo));
    });
  }
  setInterval(() => {
    if (!reduceMotion.matches && !document.hidden && !promo.matches(':hover')) showPromo(activePromo + 1);
  }, 4800);
  showPromo(0);

  // Product gallery: full-resolution local assets, with explicit selected state.
  const thumbs = $$('#mv-thumbs button');
  const galleryComment = $('[data-gallery-comment]');
  thumbs.forEach(button => button.addEventListener('click', () => {
    $('#mv-gal-main').src = button.dataset.src;
    const showComment = button === thumbs[0];
    galleryComment?.classList.toggle('is-hidden', !showComment);
    galleryComment?.setAttribute('aria-hidden', String(!showComment));
    thumbs.forEach(el => {
      const selected = el === button;
      el.classList.toggle('is-active', selected);
      el.setAttribute('aria-pressed', String(selected));
    });
  }));

  // Native scrolling keeps touch, keyboard and arrows using the same content.
  function carousel(trackSelector, prevSelector, nextSelector) {
    const track = $(trackSelector), prev = $(prevSelector), next = $(nextSelector);
    const jump = direction => {
      const first = track.firstElementChild;
      const distance = first.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0);
      track.scrollBy({ left: distance * direction, behavior: motion() });
    };
    prev.addEventListener('click', () => jump(-1));
    next.addEventListener('click', () => jump(1));
    const sync = () => {
      prev.disabled = track.scrollLeft < 2;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    };
    track.addEventListener('scroll', sync, {passive: true});
    new ResizeObserver(sync).observe(track); sync();
  }
  carousel('.mv-proof', '[data-proof-prev]', '[data-proof-next]');
  carousel('.mv-reviews', '[data-rev-prev]', '[data-rev-next]');
  const comparison = $('.mv-table-wrap'), comparisonTable=$('.mv-table');
  let competitor=2, touchStartX=0, touchStartY=0;
  function chooseCompetitor(value){
    competitor=value<2?4:value>4?2:value;
    comparisonTable.dataset.mobileCompetitor=String(competitor);
    $$('[data-competitor]').forEach(button=>button.setAttribute('aria-pressed',String(Number(button.dataset.competitor)===competitor)));
  }
  $$('[data-competitor]').forEach(button=>button.addEventListener('click',()=>chooseCompetitor(Number(button.dataset.competitor))));
  $('[data-compare-prev]').addEventListener('click',()=>chooseCompetitor(competitor-1));
  $('[data-compare-next]').addEventListener('click',()=>chooseCompetitor(competitor+1));
  comparison.addEventListener('touchstart',e=>{touchStartX=e.changedTouches[0].clientX;touchStartY=e.changedTouches[0].clientY;},{passive:true});
  comparison.addEventListener('touchend',e=>{
    const dx=e.changedTouches[0].clientX-touchStartX,dy=e.changedTouches[0].clientY-touchStartY;
    if(innerWidth<600 && Math.abs(dx)>45 && Math.abs(dx)>Math.abs(dy)*1.3) chooseCompetitor(competitor+(dx<0?1:-1));
  },{passive:true});

  // Reviews: paginate, filter and sort only the existing supplied entries.
  $$('.mv-nr-rstars').forEach(el => {
    const rating = Number(el.dataset.rating) || 5;
    el.setAttribute('role','img');el.setAttribute('aria-label',rating+' out of 5 stars');
    for (let i = 1; i <= 5; i++) {
      const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('class', 'mv-star' + (i > rating ? ' is-empty' : ''));
      svg.setAttribute('viewBox', '0 0 24 24'); svg.setAttribute('aria-hidden', 'true');
      const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path.setAttribute('d', 'm12 2 3.05 6.18 6.82 1-4.94 4.81 1.17 6.79L12 17.57l-6.1 3.21 1.16-6.79L2.12 9.18l6.83-1z');
      svg.append(path);el.append(svg);
    }
  });
  const reviewItems = $$('.mv-nr-item'), pager = $('.mv-nr-pages');
  let currentPage = 1;
  const score = el => Number($('.mv-nr-rstars',el).dataset.rating);
  function renderReviews() {
    const rating = Number($('#review-rating').value);
    const sort = $('#review-sort').value;
    let items = reviewItems.filter(el => !rating || score(el) === rating);
    if (sort !== 'original') items.sort((a,b) => (score(a)-score(b)) * (sort === 'highest' ? -1 : 1));
    const pages = Math.ceil(items.length / 4);
    currentPage = Math.min(currentPage, Math.max(pages,1));
    reviewItems.forEach(el => { el.hidden = true; });
    items.forEach((el,i) => { $('.mv-nr-list').append(el);el.hidden = i < (currentPage - 1)*4 || i >= currentPage*4; });
    pager.replaceChildren();
    function pageButton(label,page,disabled=false) {
      const button = document.createElement('button');button.type='button';button.textContent=label;button.disabled=disabled;
      if (page === currentPage && /^\d+$/.test(label)) { button.className='is-active';button.setAttribute('aria-current','page'); }
      button.setAttribute('aria-label', label === '‹' ? 'Previous review page' : label === '›' ? 'Next review page' : 'Review page '+label);
      button.addEventListener('click', () => { currentPage=page;renderReviews();$('#reviews').scrollIntoView({behavior:motion(),block:'start'}); });
      pager.append(button);
    }
    pageButton('‹',currentPage-1,currentPage===1);
    for(let p=1;p<=pages;p++)pageButton(String(p),p);
    pageButton('›',currentPage+1,currentPage===pages);
  }
  $$('.mv-nr-iconbtn').forEach(button => button.addEventListener('click', () => {
    const tools=$('.mv-review-tools');tools.hidden=!tools.hidden;
    $$('.mv-nr-iconbtn').forEach(el=>el.setAttribute('aria-pressed',String(!tools.hidden)));
    if(!tools.hidden) $(button.getAttribute('aria-label').includes('Sort')?'#review-sort':'#review-rating').focus();
  }));
  ['#review-rating','#review-sort'].forEach(selector=>$(selector).addEventListener('change',()=>{currentPage=1;renderReviews();}));
  renderReviews();

  // Cream and the real tube remain independent layers. Motion is small and optional.
  const experience = $('.mv-experience-stage');
  if (experience) {
    const finePointer = matchMedia('(hover: hover) and (pointer: fine)');
    let sceneVisible = false, scenePending = false;
    const updateScene = () => {
      scenePending = false;
      const rect = experience.getBoundingClientRect();
      const progress = Math.max(-1, Math.min(1, (innerHeight / 2 - rect.top - rect.height / 2) / (innerHeight / 2)));
      experience.style.setProperty('--scene-depth', (reduceMotion.matches ? 0 : progress * 12).toFixed(2) + 'px');
    };
    const queueScene = () => {
      if (!sceneVisible || scenePending || reduceMotion.matches) return;
      scenePending = true;
      requestAnimationFrame(updateScene);
    };
    new IntersectionObserver(entries => {
      sceneVisible = entries[0].isIntersecting;
      if (sceneVisible) updateScene();
    }, {rootMargin: '100px'}).observe(experience);
    addEventListener('scroll', queueScene, {passive: true});
    addEventListener('resize', queueScene);
    experience.addEventListener('pointermove', event => {
      if (!finePointer.matches || reduceMotion.matches) return;
      const rect = experience.getBoundingClientRect();
      experience.style.setProperty('--pointer-x', ((event.clientX - rect.left) / rect.width * 10 - 5).toFixed(2) + 'px');
      experience.style.setProperty('--pointer-y', ((event.clientY - rect.top) / rect.height * 6 - 3).toFixed(2) + 'px');
    }, {passive: true});
    const resetPointer = () => {
      experience.style.setProperty('--pointer-x', '0px');
      experience.style.setProperty('--pointer-y', '0px');
    };
    experience.addEventListener('pointerleave', resetPointer);
    reduceMotion.addEventListener('change', () => { resetPointer(); updateScene(); });
  }

  // Ritual illustrations play automatically in view and honor reduced motion.
  const ritual = $('#ritual');
  const ritualArt = $$('[data-ritual-art]', ritual);
  const syncRitualMotion = () => {
    const stopped = reduceMotion.matches || document.hidden;
    ritualArt.forEach(art => {
      const playing = !stopped && art.dataset.inView === 'true';
      art.classList.toggle('is-static', !playing);
      art.classList.toggle('is-playing', playing);
    });
  };
  const ritualObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => { entry.target.dataset.inView = String(entry.isIntersecting && entry.intersectionRatio >= 0.35); });
    syncRitualMotion();
  }, {threshold: 0.35});
  ritualArt.forEach(art => ritualObserver.observe(art));
  document.addEventListener('visibilitychange', syncRitualMotion);
  reduceMotion.addEventListener('change', syncRitualMotion);
  syncRitualMotion();

  // Sticky only after the hero, and never while the offer/final CTA is in view.
  const sticky=$('#mv-sticky'), hero=$('#hero'), offer=$('#mv-offer'), final=$('#final-close');
  let dismissed=false;
  const inView=el=>{const r=el.getBoundingClientRect();return r.bottom>0 && r.top<innerHeight;};
  const syncSticky=()=>{
    const nearbyCta=$$('.mv-btn').some(el=>!el.closest('.mv-sticky') && inView(el));
    const shown=innerWidth<768 && !nearbyCta && !dismissed && hero.getBoundingClientRect().bottom<0 && !inView(offer) && !inView(final) && !dialog.open;
    sticky.classList.toggle('is-visible',shown);sticky.setAttribute('aria-hidden',String(!shown));
  };
  $('.mv-sticky-close').addEventListener('click',()=>{dismissed=true;syncSticky();});
  const observer=new IntersectionObserver(syncSticky,{threshold:[0,1]});
  [hero,offer,final].forEach(el=>observer.observe(el));
  let scheduled=false;
  addEventListener('scroll',()=>{if(!scheduled){scheduled=true;requestAnimationFrame(()=>{scheduled=false;syncSticky();});}},{passive:true});
  addEventListener('resize',syncSticky);dialog.addEventListener('close',syncSticky);syncSticky();
})();
